import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <about>

      <section className="bg-gradient-to-br from-gray-800 to-blue-600">
        <div className="max-w-4xl mx-auto px-6 pt-16 pb-16">

          <h1 className="text-4xl font-bold pb-8">
            About
          </h1>

          <p className="md:text-xl max-w-3xl mx-auto pb-6 text-left">
            I’m an iOS Software Engineer focused on designing, building,
            shipping, and maintaining native applications with Swift and
            SwiftUI.
          </p>

          <p className="md:text-xl max-w-3xl mx-auto pb-6 text-left">
            My recent work includes two production App Store applications:
            True Lock Tuner and SnoozeLock. Building these products has given
            me hands-on experience with real-time audio processing, native
            device integrations, state-driven application architecture,
            StoreKit monetization, analytics, physical-device testing, and the
            complete App Store release lifecycle.
          </p>

          <p className="md:text-xl max-w-3xl mx-auto pb-6 text-left">
            I approach software development from both an engineering and
            product perspective. I enjoy translating user needs into technical
            solutions, evaluating tradeoffs, iterating on shipped software, and
            taking ownership of the result rather than focusing only on
            isolated features.
          </p>

          <p className="md:text-xl max-w-3xl mx-auto pb-10 text-left">
            My broader background includes JavaScript, React, Python, Django, REST APIs, databases, web development, and technical SEO for client businesses. Before shifting my primary focus to iOS, much of my work centered on web development and SEO, and I continue to support a smaller number of SEO engagements today. That experience gives me additional perspective when working across systems, products, analytics, and multidisciplinary teams.
          </p>

          <div className="about-buttons">
            <Link to="/projects">
              <button className="project-button">
                View Projects
              </button>
            </Link>

            <a
              href="/greg-swan-resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="project-button">
                Resume
              </button>
            </a>
          </div>

        </div>
      </section>


      <section className="bg-gradient-to-br from-gray-900 to-gray-600">
        <div className="max-w-5xl mx-auto px-6 pt-16 pb-16">

          <h2 className="text-3xl font-bold pb-10">
            Technical Focus
          </h2>


          <div className="about-skills-grid">

            <div className="about-skill-card">
              <h3 className="text-2xl font-bold pb-4">
                Native iOS
              </h3>

              <p className="md:text-xl">
                Swift • SwiftUI • Xcode • AVFoundation • AlarmKit •
                CoreMotion • StoreKit 2 • async/await • Combine
              </p>
            </div>


            <div className="about-skill-card">
              <h3 className="text-2xl font-bold pb-4">
                Engineering
              </h3>

              <p className="md:text-xl">
                MVVM • REST APIs • Git/GitHub • Analytics • Debugging •
                Physical-Device Testing • LLM-Assisted Development
              </p>
            </div>


            <div className="about-skill-card">
              <h3 className="text-2xl font-bold pb-4">
                App Distribution
              </h3>

              <p className="md:text-xl">
                App Store Connect • TestFlight • StoreKit Testing •
                Privacy & Compliance • App Review • Release Management
              </p>
            </div>


            <div className="about-skill-card">
              <h3 className="text-2xl font-bold pb-4">
                Additional Experience
              </h3>

              <p className="md:text-xl">
                JavaScript • React • Python • Django • PostgreSQL • AWS
              </p>
            </div>

          </div>

        </div>
      </section>

    </about>
  );
}

